export enum QueryKeys {
  SURVEY_DEFINITIONS = 'surveyDefinitions',
  SURVEY_RESPONSES = 'surveyResponses',
  SURVEY_RESPONSES_DIRECT = 'surveyResponses_direct',
  CUSTOMER_VISITS = 'customerVisits',
  PRODUCTS = 'products',
  MODIFIED_DATES = 'modifiedDates',
  BLOBS = 'blobs'
}
